// extracted by mini-css-extract-plugin
export default {"title-section":"_9Gospvi-Yx","titleSection":"_9Gospvi-Yx","table":"+hC496okNq","status":"qavEas4X28"};